/**
 * Created by Astha on 7/12/2019.
 */
import React from "react";
import Popup from "../common/Popup";
import {Portal} from "react-portal";
import renderMetadataForm from "../metadata/renderMetadataForm";
import renderAiForm from "./renderAiForm";

type
Props = {
  style: Object,
  onClose: Function
};
export default class AiDataPopup extends React.Component<Props, State> {
  constructor(props) {
    super(props);
  }


  render() {
    const {
      style,
      onClose
    } = this.props;
    return (
      <div>
        <Popup style={style} onClose={onClose} bottom>
          <div
            name="AiDataPopup">
          </div>
          {renderAiForm(undefined)}
        </Popup>
      </div>
    )
  }

}
